import React, { Component } from 'react'
import {Chart, registerables} from "chart.js";

//import classes from "./LineGraph.module.css";
import "./LineGraph.css";

export default class BarGraph extends Component {
    constructor(props) {
        super(props);

        this.chartobj = undefined;
        this.maxTicks = 5
    }
    chartRef = React.createRef();
    
    componentDidMount() {
        Chart.register(...registerables);
        this.chart();
    }

    componentDidUpdate(prevprops) {
        if (this.seriesChanged(prevprops)) {
            this.maxTicks = Array.isArray(this.props.series1) ? 
              Math.min(1+Math.max(...this.props.series1), 8) : 5
            this.setData()
            this.chartobj.update()
        }
    }
    componentWillUnmount(){
        if (typeof this.chartobj !== "undefined")
            this.chartobj.destroy();
    }
    seriesChanged (prevprops) {
        if (prevprops?.series1?.length && this.props?.series1?.length)
            return !this.arrayMatch (prevprops.series1, this.props.series1)
        else
            return this.props?.series1?.length > 0
    }
    arrayMatch (array1, array2) {
        return array1.length === array2.length && array1.every((value, index) => value === array2[index])
    }
    fillColor() {
        let result = this.props?.colors ?? [];
        while(result.length < this.props?.series1?.length)
            result.push("#0fc0a4")
        return result;
    }
    setData () {
      if (typeof this.chartobj !== 'undefined') {
            this.chartobj.data.datasets[0].data = this.props.series1;
            this.chartobj.data.datasets[0].backgroundColor = this.fillColor()
            this.chartobj.data.labels = this.props.label
            this.chartobj.options.scales.y.ticks.maxTicksLimit = this.maxTicks
      }   
    }
    chart () {
        const myChartRef = this.chartRef.current.getContext("2d");
        if (typeof this.chartobj !== "undefined") this.chartobj.destroy();
        this.chartobj = new Chart(myChartRef, {
            type: "bar",
            data: {
                //Bring in data
                labels: this.props.label,
                datasets: [
                    {
                        label: "Devices",
                        data: this.props.series1,
                        backgroundColor: this.fillColor(),
                    }
                ]
            },
            options: {
                plugins: {
                    legend: {display: false}
                },
                scales: {
                    x: {
                        grid: { display: false}
                    },
                    y: {
                        ticks: { 
                            display: true,
                            maxTicksLimit: this.maxTicks
                         },
                        grid: { display: false }
                    }
                },
                onClick(e) {
                    const activePoints = this.$context.chart.getElementsAtEventForMode(
                        e, 'nearest', {intersect: true}, false
                    )
                    if (self.props?.onClick)
                        self.props.onClick (activePoints)
                }
            }
        });
        const self = this
    }

    render() {
        return (
            <div className='histogram-panel'>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>
        )
    }
}
